<template>
  <div>
    <el-card>
      <div class="page-desc">汉英小程序练习题试卷管理：创建试卷、上传题目、预览、修改等。</div>
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        label-width="80px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="赛事活动" prop="activityType">
              <el-select
                disabled
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.activityType"
                @change="getRaceSchedules"
              >
                <el-option
                  v-for="item in activityTypeList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="赛程" prop="raceSchedule">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.raceSchedule"
              >
                <el-option
                  v-for="item in raceSchedules"
                  :key="item.id"
                  :label="item.scheduleName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="组别" prop="quizLevel">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.quizLevel"
              >
                <el-option
                  v-for="item in dict_group"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="试卷名称" prop="formName">
              <el-input
                v-model="queryForm.formName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="searchFn"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="resetFn"
            >重置</el-button
          >
        </el-col>
      </el-row>
      </el-form>
    </el-card>
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="12">
          <span class="title_class">试卷列表</span>
        </el-col>
        <el-col :span="12" style="text-align: right;">
          <el-button type="primary" @click="showDialog()"
            >创建试卷</el-button>
        </el-col>
      </el-row>
      <!-- 列表表格区域 -->
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="所属产品" prop="productTypeStr"></el-table-column>
        <el-table-column label="试卷名称" prop="formName"></el-table-column>
        <el-table-column label="试卷英文名称" prop="formEngName"></el-table-column>
        <el-table-column label="题目类型" prop="quizForm">
          <template slot-scope="scope">
            <el-tag :type="scope.row.quizForm === 1 ? 'warning' : 'success'" size="mini">
              {{ scope.row.quizForm === 1 ? '题型演示' : '正式作答' }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="赛程" prop="raceSchedule" :formatter="raceScheduleFormatter"></el-table-column> -->
        <el-table-column label="组别" prop="quizLevel" :formatter="groupFormatter"></el-table-column>
        <!-- <el-table-column label="状态" prop="status">
          <template slot-scope="scope">
            <el-switch style="margin-left: 12px;"
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="changeStatus()"
              >
            </el-switch>
            {{ scope.row.status ? '启用' : '禁用' }}
          </template>
        </el-table-column> -->
        <el-table-column label="创建者" prop="creator"></el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              icon="el-icon-edit"
              @click="handleToEdit(scope.row)"
            >修改</el-button>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-document"
              @click="handleToDetail(scope.row)"
            >查看题目</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title=" editType === 0 ? '创建试卷' : '修改试卷'"
      :visible.sync="visible"
      width="800px"
      :close-on-click-modal="false"
      :before-close="handleClose"
      >
      <el-form
        :model="addForm"
        label-width="110px"
        ref="editFormRef"
        :rules="editFormRules"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="赛事活动" prop="activityType">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addForm.activityType"
                disabled
              >
                <el-option
                  v-for="item in activityTypeList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addForm.season"
                :disabled="editType === 1"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="赛程" prop="raceSchedule">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addForm.raceSchedule"
              >
                <el-option
                  v-for="item in raceSchedules"
                  :key="item.id"
                  :label="item.scheduleName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="组别" prop="quizLevel">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addForm.quizLevel"
                :disabled="editType === 1"
              >
                <el-option
                  v-for="item in dict_group"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="题目类型" prop="quizForm">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addForm.quizForm"
                :disabled="editType === 1"
              >
                <el-option label="题型演示" :value="1"></el-option>
                <el-option label="正式作答" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="试卷名称" prop="formName">
              <el-input
                v-model="addForm.formName"
                placeholder="建议不超过10字"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="试卷英文名称" prop="formEngName">
              <el-input
                v-model="addForm.formEngName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="editType === 0">
            <el-form-item label="上传题目">
              <el-upload
                class="upload-demo"
                drag
                ref="uploadFileRef"
                :action="uploadInfo.uploadUrl"
                :headers="uploadInfo.headerObj"
                :data="addForm"
                :before-upload="beforeUpload"
                :limit="1"
                :on-success="uploadSuccess"
                :on-error="uploadError">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">支持上传Excel文件， <em class="tip" @click="downLoadFn">点击下载模版</em></div>
              </el-upload>
              <div class="rule-tip">
                图片命名规则：<br/>
                组名_题号_选项号.png（例如 Advanced_13_1.png）<br/>
                小初组 Beginner 小中组Intermediate 小高组Advanced 初中组Middle
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" v-if="editType === 1" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="editSave">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import env from '@/http/env'

export default {
  data () {
    return {
      activityTypeList: this.$userInfo.getDataList(this, 'activity_type').then(value => { this.activityTypeList = value }),
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      dict_group: this.$userInfo.dict_group(),
      raceSchedules: [],
      queryForm: {
        pageNum: 1,
        pageSize: 20,
        activityType: String(this.$chnEngStatusCode.activityType),
        season: this.$chnEngStatusCode.defaultSeason,
        // raceSchedule: '',
        // quizSet: '', // 待定
        quizLevel: '',
        // quizForm: '', // 题型先不写
        formName: ''
      },
      total: 0,
      dataList: [],
      visible: false,
      editType: 0,
      addForm: {
        activityType: String(this.$chnEngStatusCode.activityType),
        season: this.$chnEngStatusCode.defaultSeason,
        // raceSchedule: '',
        quizLevel: '',
        // quizSet: '',
        quizForm: '',
        formName: '',
        formEngName: ''
      },
      editFormRules: {
        quizLevel: [{ required: true, message: '请选择组别', trigger: 'change' }],
        quizForm: [{ required: true, message: '请选择题目类型', trigger: 'change' }],
        formName: [{ required: true, message: '请输入试卷名称', trigger: 'blur' }],
        formEngName: [{ required: true, message: '请输入试卷英文名称', trigger: 'blur' }]
      },
      uploadInfo: {
        uploadUrl: `${this.$http.defaults.baseURL}quiz/importExamQuizExcel`,
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      }
    }
  },
  created () {
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    init () {
      this.getRaceSchedules()
    },
    getRaceSchedules (type) {
      this.dataList = []
      this.$http.get('raceSchedule/queryRaceSchedule', { params: { activityType: this.queryForm.activityType } }).then(res => {
        if (res.code === 200) {
          this.raceSchedules = res.data
          this.getList()
        }
      })
    },
    getList () {
      console.log(this.queryForm)
      this.$http.get('quiz/queryExamQuizPage', { params: this.queryForm }).then(res => {
        if (res.code === 200) {
          this.total = res.data.total
          this.dataList = res.data.list
        }
      })
    },
    searchFn () {
      this.queryForm.pageNum = 1
      this.getList()
    },
    resetFn () {
      this.$refs.queryFormRef.resetFields()
      this.queryForm.activityType = String(this.$chnEngStatusCode.activityType)
      this.queryForm.season = this.$chnEngStatusCode.defaultSeason
      this.getRaceSchedules()
    },
    handleCurrentChange (e) {
      this.queryForm.pageNum = e
      this.getList()
    },
    handleSizeChange (e) {
      this.queryForm.pageSize = e
      this.getList()
    },
    handleToDetail (item) {
      const formInfo = {
        activityType: item.activityType,
        season: item.season,
        quizLevel: item.quizLevel
      }
      this.$router.push(`/academic_Management/paper_detail?id=${item.id}&paper=${item.formName}&type=3&formInfo=${JSON.stringify(formInfo)}`)
    },
    groupFormatter (data) {
      return data.quizLevel ? this.dict_group.find(item => item.dictCode === data.quizLevel).dictLabel : '--'
    },
    // raceScheduleFormatter (data) {
    //   return this.raceSchedules.find(item => item.id === String(data.raceSchedule)).scheduleName
    // },
    showDialog () {
      this.editType = 0
      this.visible = true
      this.addForm = {
        activityType: String(this.$chnEngStatusCode.activityType),
        season: this.$chnEngStatusCode.defaultSeason,
        raceSchedule: '',
        quizLevel: '',
        quizForm: '',
        formName: '',
        formEngName: ''
      }
    },
    handleClose () {
      this.visible = false
    },
    // 下载模板
    downLoadFn () {
      var downLoadUrl = env.baseIP + 'quiz/importExamQuizExcel'
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, {})
    },
    beforeUpload (file) {
      this.$refs.editFormRef.validate(valid => {
        if (!valid) return
        if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          this.$message.error('请选择Excel文件上传')
          return false
        }
      })
    },
    uploadSuccess (res) {
      if (res.code === 200) {
        this.$message.success('上传成功')
        this.visible = false
        this.searchFn()
      } else {
        this.$message.error(res.msg)
      }
      this.$refs.uploadFileRef.clearFiles()// 清除文件
    },
    uploadError (error) {
      console.log('uploadError', error)
    },
    changeStatus (item) {
      this.$http.post('coupon/updateTbCouponInfo', { id: item.id, status: item.status }).then(res => {
        if (res.code === 200) {
          this.$message.success(item.status ? '试卷已启用' : '试卷已禁用')
          this.getDataList()
        }
      })
    },
    handleToEdit (item) {
      this.editType = 1
      this.visible = true
      this.addForm.quizLevel = String(item.quizLevel)
      this.addForm.quizForm = item.quizForm
      this.addForm.formName = item.formName
      this.addForm.formEngName = item.formEngName
      this.editId = item.id
    },
    editSave () {
      this.$refs.editFormRef.validate(valid => {
        if (!valid) return
        const params = {
          id: this.editId,
          formName: this.addForm.formName,
          formEngName: this.addForm.formEngName
        }
        this.$http.get('quiz/updateDataQuiz', { params }).then(res => {
          if (res.code === 200) {
            this.visible = false
            this.$message.success('修改成功')
            this.getList()
          }
        })
      })
    }
  }
}
</script>
<style scoped lang="less">
.tip{
  line-height: initial;
  color: #409eff;
  font-size: 12px;
  cursor: pointer;
  width: 74px;
}
.rule-tip{
  color: #999;
  font-size: 12px;
  line-height: 20px;
  margin-top: 10px;
}
.el-upload__tip{
  margin-top: 0;
  line-height: 20px;
}
</style>
